module.exports = __webpack_public_path__ + "static/media/product_overview.015e30dd.gif";